import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { Document } from 'modules/documents/hooks/documents/useGetDocuments'

interface Props {
  documents: Document[]
  index: number
}

const Counter = ({ documents, index }: Props) => {
  if (documents.length < 2) return null

  return (
    <Box alignItems="center" justifyContent="center">
      <Text.Normal size="200" color="grey800">
        {i18n.t('split_documents.header.file_of', { current: index + 1, total: documents.length })}
      </Text.Normal>
    </Box>
  )
}

export default Counter
